module.exports = __webpack_public_path__ + "static/media/front.e2ea8e67.png";